import { useEffect, useContext } from "react";
import PropTypes from "prop-types";
import { useSolicitudesPendientes } from "./useSolicitudesPendientes";
import { ModalContractuales } from "../../modalForm/modalForm";
import { customStyles, paginationComponentOptions } from "../../../utils/Constants";
import { DataContextContractual } from "../../../contextData/contextData";
import DataTable from "react-data-table-component";
import { useIndex } from "../../useIndex";

export const SolicitudesTraspaso = (props) => {
  const { listado } = props;
  const { arrColumnas, visible, hideModal, objDataModal, tamanioModal } = useSolicitudesPendientes();
  const { visibleModalForm, setVisibleModalForm, dataModalForm } = useContext(DataContextContractual);

  const { traerData } = useIndex();

  useEffect(() => {
    traerData();
  }, []);

  return (
    <>
      <ModalContractuales data={objDataModal} show={visible} hideModal={hideModal} tamanio={tamanioModal} />
      <ModalContractuales
        data={dataModalForm}
        show={visibleModalForm}
        hideModal={() => {
          setVisibleModalForm(false);
        }}
        tamanio="md"
      />
      <div className="d-flex align-items-center flex-column">
        <div className="col col-12 col-lg-10 px-4">
          <DataTable
            data={listado}
            dense
            columns={arrColumnas}
            customStyles={customStyles}
            noHeader
            pagination
            noDataComponent="No hay solicitudes de traspaso disponibles"
            style={{ height: "200px" }}
            paginationComponentOptions={paginationComponentOptions}
          />
        </div>
      </div>
    </>
  );
};

SolicitudesTraspaso.propTypes = {
  listado: PropTypes.array.isRequired,
};
